/**
 * Saved view contracts — DESIGN.md §7.6 (R20).
 *
 * "Any user can adjust any view surface … Adjustments to a saved view are
 * **local until saved**: 'Save' (own personal views), 'Save as new view', or
 * — the R20 requirement — **'Publish as shared view'**, which sets
 * `scope='shared'` and makes it appear for ALL users."
 */
import { z } from 'zod';
import { VIEW_SCOPES, VIEW_TYPES } from '../enums.js';
import { name, uuidSchema } from './common.js';
import { viewConfigSchema } from './view-config.js';
import { userRefSchema } from './users.js';
export const viewSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    type: z.enum(VIEW_TYPES),
    scope: z.enum(VIEW_SCOPES),
    owner: userRefSchema,
    projectId: uuidSchema.nullable(),
    config: viewConfigSchema,
    createdAt: z.string(),
    updatedAt: z.string(),
    /** Whether the viewer may edit or delete it — owner, or admin (§7.6). */
    canEdit: z.boolean(),
    /** Set when a project opens on this view (§7.6). */
    isProjectDefault: z.boolean(),
});
export const createViewRequestSchema = z
    .object({
    name: name(120),
    type: z.enum(VIEW_TYPES).default('list'),
    scope: z.enum(VIEW_SCOPES).default('personal'),
    projectId: uuidSchema.nullish(),
    config: viewConfigSchema,
})
    .strict();
export const updateViewRequestSchema = z
    .object({
    name: name(120).optional(),
    type: z.enum(VIEW_TYPES).optional(),
    config: viewConfigSchema.optional(),
})
    .strict();
export const listViewsQuerySchema = z.object({
    /** Restrict to one project's views; omit for the global list. */
    projectId: uuidSchema.optional(),
    scope: z.enum(['personal', 'shared', 'all']).default('all'),
});
export const shareViewRequestSchema = z.object({ shared: z.boolean() }).strict();
export const duplicateViewRequestSchema = z.object({ name: name(120).optional() }).strict();
//# sourceMappingURL=views.js.map